import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=0da5592e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=0da5592e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da5592e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da5592e')) {
      api.createRecord('0da5592e', component.options)
    } else {
      api.reload('0da5592e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=0da5592e&scoped=true&", function () {
      api.rerender('0da5592e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JOVLPPj0yi3A/JS/comp/SearchFilterTokens.vue"
export default component.exports